import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_5K_5C = () => <CrossRoad coords="1807.000000, 499.000000"/>;

export default CrossRoad_5K_5C;
